/**
 * RAKNIDA · Quick View + Mini Cart — shop v14.4
 */
(function () {
  'use strict';

  if (window.RaknidaQV) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MONEY_FORMAT = (window.theme && theme.moneyFormat) || (window.Shopify && Shopify.money_format) || '${{amount}}';
  /* §4.9: free US shipping on orders of $150 or more. Was 30000 ($300). */
  var SHIP_FREE_CENTS = 15000;

  var TIER_META = {
    open: {
      label: 'Studio Edition',
      paperLabel: 'Museum-grade cotton paper',
      longevity: 'Archival pigment inks',
      fees: [0, 25, 45, 75],
      incl: ['Cultural Passport card', 'Edition number printed in the border'],
      trust: ['Museum-quality giclée', 'Free US shipping from $150', '7-day replacement']
    },
    collector: {
      label: 'Collector Edition',
      paperLabel: 'Museum-grade cotton paper',
      longevity: 'Archival pigment inks',
      fees: [0, 45, 80, 120],
      incl: ['Cultural Passport card', 'Digital Certificate of Authenticity', 'Edition number printed in the border'],
      trust: ['Museum-quality giclée', 'Free US shipping from $150', '7-day replacement']
    },
    limited: {
      label: 'Limited Edition',
      paperLabel: 'Museum-grade cotton paper',
      longevity: 'Archival pigment inks',
      fees: [0, 60, 95, 150],
      incl: [
        'Cultural Passport card',
        'Certificate of Authenticity signed by the curator or founder — mailed separately',
        'Edition number printed in the border',
        'Final edition — never rerun'
      ],
      trust: ['Museum-quality giclée', 'Free US shipping', '7-day replacement']
    },
    signature: {
      label: 'Signature',
      paperLabel: 'Museum-grade cotton paper',
      longevity: 'Framing included on Editions',
      fees: [0, 0, 0, 0],
      incl: ['Cultural Passport card', 'Certificate of Authenticity'],
      trust: ['Museum-quality giclée', 'Curated showcase']
    }
  };

  function money(cents) {
    var amount = (Number(cents) || 0) / 100;
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, MONEY_FORMAT); } catch (e) {}
    }
    return '$' + amount.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function dollars(n) {
    return '$' + Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 0 });
  }

  function el(html) {
    var d = document.createElement('div');
    d.innerHTML = html.trim();
    return d.firstChild;
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function rootPath() { return ROOT.replace(/\/?$/, '/'); }
  function cartUrl() { return rootPath() + 'cart.js'; }
  function addUrl() { return rootPath() + 'cart/add.js'; }
  function changeUrl() { return rootPath() + 'cart/change.js'; }
  function productJs(handle) { return rootPath() + 'products/' + handle + '.js'; }

  function wishEntryId(entry) {
    return String(entry && entry.id != null ? entry.id : entry);
  }

  function normalizeWishEntry(item) {
    if (item && typeof item === 'object' && item.id != null) {
      return { id: String(item.id), handle: String(item.handle || '') };
    }
    var id = String(item);
    var card = document.querySelector('.rk-pc[data-product-id="' + id + '"]');
    return { id: id, handle: card ? (card.getAttribute('data-handle') || '') : '' };
  }

  function getWish() {
    try {
      var raw = JSON.parse(localStorage.getItem('rk-wishlist') || '[]');
      if (!Array.isArray(raw)) return [];
      return raw.map(normalizeWishEntry).filter(function (e) { return e.id; });
    } catch (e) { return []; }
  }

  function setWish(entries) {
    var clean = (entries || []).map(normalizeWishEntry).filter(function (e) { return e.id; });
    try { localStorage.setItem('rk-wishlist', JSON.stringify(clean)); } catch (e) {}
    updateWishBadge(clean.length);
    document.dispatchEvent(new CustomEvent('rk-wishlist-change'));
  }

  function tierLabelFromProduct(p) {
    var blob = ((p.tags || '') + ' ' + (p.product_type || '') + ' ' + (p.title || '')).toLowerCase();
    if (/limited/.test(blob)) return 'Limited Edition';
    if (/collector/.test(blob)) return 'Collector Edition';
    if (/signature/.test(blob)) return 'Signature';
    return 'Studio Edition';
  }

  function tierSlugFromLabel(label) {
    var tl = String(label || '').toLowerCase();
    if (tl.indexOf('limited') !== -1) return 'limited';
    if (tl.indexOf('collector') !== -1) return 'collector';
    if (tl.indexOf('signature') !== -1) return 'signature';
    return 'open';
  }

  function reconcileCardTierFromProduct(card, product) {
    if (!card) card = {};
    if (!product) return card;
    var fromProduct = tierLabelFromProduct(product);
    var productSlug = tierSlugFromLabel(fromProduct);
    var cardSlug = String(card.tier || 'open').toLowerCase().replace(/[^a-z0-9-]/g, '') || 'open';
    var badge = String(card.badge || '').toLowerCase();
    if (badge.indexOf('ltd') !== -1 || badge.indexOf('limited') !== -1) {
      card.tier = 'limited';
      card.tierLabel = card.tierLabel || 'Limited Edition';
      return card;
    }
    if (badge.indexOf('coll') !== -1) {
      card.tier = 'collector';
      card.tierLabel = card.tierLabel || 'Collector Edition';
      return card;
    }
    // Prefer product tags when the card defaulted to open (common for JS recent cards)
    if (productSlug !== 'open' && (cardSlug === 'open' || !card.tierLabel)) {
      card.tier = productSlug;
      card.tierLabel = fromProduct;
    } else if (!card.tierLabel && fromProduct) {
      card.tierLabel = fromProduct;
      card.tier = productSlug;
    }
    return card;
  }

  function firstAvailableVariant(p) {
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) if (vs[i].available) return vs[i];
    return vs[0] || null;
  }

  function shopCollectionUrl() {
    return rootPath() + 'collections/all?view=shop';
  }

  var FRAMED_PREVIEW = '__framed_preview__';

  var state = {
    product: null,
    card: null,
    sizeLabel: '',
    finishLabel: '',
    tab: 'artwork',
    mediaIndex: 0,
    mediaSlots: [],
    inclOpen: false,
    noteOpen: false,
    framePreview: false,
    finInfoOpen: false,
    open: false,
    shareOpen: false,
    payReq: 0
  };

  function ensureUI() {
    if (!document.getElementById('rk-qv-root')) {
      document.body.appendChild(el(
        '<div class="rk-qv-ov" id="rk-qv-root" hidden role="dialog" aria-modal="true" aria-label="Quick view">' +
          '<div class="rk-qv-m" data-rk-qv-panel>' +
            '<div class="rk-qv-left">' +
              '<div class="rk-qv-handle" aria-hidden="true"><span></span></div>' +
              '<div class="rk-qv-stage" data-rk-qv-stage role="group">' +
                '<div class="rk-qv-media-slots" data-rk-qv-media-slots></div>' +
                '<span class="rk-qv-count" data-rk-qv-count></span>' +
                '<button type="button" class="rk-qv-nav rk-qv-nav--prev" data-rk-qv-media-prev aria-label="Previous media">‹</button>' +
                '<button type="button" class="rk-qv-nav rk-qv-nav--next" data-rk-qv-media-next aria-label="Next media">›</button>' +
                '<button type="button" class="rk-qv-close" data-rk-qv-close aria-label="Close quick view">×</button>' +
              '</div>' +
              '<div class="rk-qv-thumbs" data-rk-qv-thumbs role="tablist" aria-label="Artwork media"></div>' +
            '</div>' +
            '<div class="rk-qv-right">' +
              '<div class="rk-qv-scroll" data-rk-qv-scroll></div>' +
              '<div class="rk-qv-sticky">' +
                '<button type="button" class="rk-qv-atc" data-rk-qv-atc>Add to Cart</button>' +
                '<button type="button" class="rk-qv-icon-btn" data-rk-qv-wish aria-label="Wishlist">' +
                  '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>' +
                '</button>' +
                '<div class="rk-qv-share-wrap">' +
                  '<button type="button" class="rk-qv-icon-btn" data-rk-qv-share aria-label="Share">' +
                    '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>' +
                  '</button>' +
                  '<div class="rk-qv-share-sheet" data-rk-qv-share-sheet hidden>' +
                    '<button type="button" class="rk-qv-share-opt" data-rk-share="copy">Copy Link</button>' +
                    '<button type="button" class="rk-qv-share-opt" data-rk-share="pinterest">Pinterest</button>' +
                    '<button type="button" class="rk-qv-share-opt" data-rk-share="email">Email to a Friend</button>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>'
      ));
    }
    document.querySelectorAll('.rk-qv-tabs').forEach(function (n) { n.remove(); });

    if (!document.getElementById('rk-ar-root')) {
      document.body.appendChild(el(
        '<div class="rk-ar-ov" id="rk-ar-root" hidden data-rk-ar-ov>' +
          '<div class="rk-ar-bg"></div>' +
          '<div class="rk-ar-frame" data-rk-ar-frame><img data-rk-ar-img alt=""></div>' +
          '<div class="rk-ar-footer">' +
            '<p data-rk-ar-label>Preview</p>' +
            '<p class="rk-ar-sub">Museum-Quality Print at this size · Tap anywhere to close</p>' +
            '<button type="button" class="rk-qv-atc" data-rk-ar-atc>Add to Cart</button>' +
          '</div>' +
        '</div>'
      ));
    }

    var slot = document.querySelector('[data-rk-cart-slot]');
    if (slot && !slot.querySelector('[data-rk-mini-cart]')) {
      slot.appendChild(el('<div class="rk-mini-cart" data-rk-mini-cart hidden role="dialog" aria-label="Mini cart"></div>'));
    }

    var wishSlot = document.querySelector('[data-rk-wish-slot]');
    if (wishSlot && !wishSlot.querySelector('[data-rk-mini-wish]')) {
      wishSlot.appendChild(el('<div class="rk-mini-wish" data-rk-mini-wish hidden role="dialog" aria-label="Wishlist"></div>'));
    }
  }

  function updateWishBadge(count) {
    if (typeof count !== 'number') count = getWish().length;
    document.querySelectorAll('[data-rk-wishlist-badge]').forEach(function (b) {
      if (count > 0) { b.hidden = false; b.textContent = String(count); }
      else b.hidden = true;
    });
    document.querySelectorAll('[data-rk-wishlist-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-label', 'Wishlist (' + count + ' item' + (count === 1 ? '' : 's') + ')');
    });
  }

  function updateBadge(count) {
    document.querySelectorAll('[data-rk-cart-badge]').forEach(function (b) {
      if (count > 0) { b.hidden = false; b.textContent = String(count); }
      else b.hidden = true;
    });
    document.querySelectorAll('[data-rk-cart-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-label', 'Cart (' + count + ' items)');
    });
  }

  function hasMounted(items) {
    return (items || []).some(function (it) {
      var f = (it.properties && (it.properties.Finish || it.properties.finish)) || '';
      return /frameless|mounted/i.test(String(f));
    });
  }

  function renderMiniCart(cart) {
    ensureUI();
    var box = document.querySelector('[data-rk-mini-cart]');
    if (!box) return;
    var items = (cart && cart.items) || [];
    var count = cart && typeof cart.item_count === 'number' ? cart.item_count : items.length;
    var total = cart && cart.total_price != null ? cart.total_price : 0;
    updateBadge(count);

    var html = '<div class="rk-mc-head"><p class="rk-mc-head-title">Your Cart</p>' +
      /* No Clear control here, deliberately. One was added on 2026-10-06 and removed
         the same day on the user's instruction: "users should not be able to clear
         cart at all". Emptying a basket is irreversible, Shopify offers no undo, and
         the control sat a thumb's width from Checkout. Individual lines can still be
         removed, which is the recoverable version of the same intent. */
      '<span class="rk-mc-head-right"><p class="rk-mc-head-count">' +
      count + (count === 1 ? ' item' : ' items') + '</p>' +
      '</span></div>';

    if (!items.length) {
      html += '<div class="rk-mc-empty"><p class="rk-mc-empty-h">Your cart is empty</p>' +
        '<p class="rk-mc-empty-p">Browse the collection to add your first artwork.</p>' +
        '<button type="button" class="rk-mc-btn rk-mc-btn--ghost" data-rk-mc-close>Continue Browsing</button></div>';
    } else {
      html += '<div class="rk-mc-items">';
      /* No reverse: Shopify's cart.js already returns the most recently added line
         first, which is what /cart renders. Reversing here put the oldest on top and
         made the two disagree. No slice either - the list scrolls (rk-qv.css). */
      items.forEach(function (it) {
        var props = it.properties || {};
        var finish = props.Finish || props.finish || '';
        var size = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        var opts = [size, finish].filter(Boolean).join(' · ');
        html += '<div class="rk-mc-row">' +
          (it.image ? '<img class="rk-mc-thumb" src="' + esc(it.image) + '" alt="" width="54" height="68" loading="lazy">' : '<div class="rk-mc-thumb"></div>') +
          '<div class="rk-mc-meta">' +
            '<p class="rk-mc-title">' + esc(it.product_title || it.title || '') + '</p>' +
            (it.vendor ? '<p class="rk-mc-artist">' + esc(it.vendor) + '</p>' : '') +
            (opts ? '<p class="rk-mc-opts">' + esc(opts) + '</p>' : '') +
            '<p class="rk-mc-price">' + money(it.final_line_price || it.line_price || it.price) + '</p>' +
          '</div>' +
          '<button type="button" class="rk-mc-remove" data-rk-mc-remove="' + esc(it.key) + '" aria-label="Remove from cart">×</button>' +
        '</div>';
      });

      html += '</div>';

      /* The Frameless Mounted exception is gone with the finish itself (§4.5:
         "Mounted is discontinued"). It let an order qualify below the threshold and,
         worse, advertised a finish nobody can buy as the way to get there. */
      var qualifies = total >= SHIP_FREE_CENTS;
      html += '<div class="rk-mc-ship">';
      if (qualifies) {
        html += '<p class="rk-mc-ship-ok"><span>✓</span>Free US shipping unlocked</p>';
      } else {
        html += '<p class="rk-mc-ship-msg">Add <strong>$' + Math.ceil((SHIP_FREE_CENTS - total) / 100) +
          '</strong> more for free US shipping</p>' +
          '<div class="rk-mc-ship-bar"><div class="rk-mc-ship-fill" style="width:' +
          Math.min(100, (total / SHIP_FREE_CENTS) * 100) + '%"></div></div>';
      }
      html += '</div>';
      html += '<div class="rk-mc-sub"><p class="rk-mc-sub-lab">Subtotal</p><p class="rk-mc-sub-val">' + money(total) + '</p></div>';
      html += '<div class="rk-mc-actions">' +
        '<a class="rk-mc-btn rk-mc-btn--ghost" href="' + rootPath() + 'cart">View Cart</a>' +
        '<a class="rk-mc-btn rk-mc-btn--brass" href="/checkout">Checkout</a></div>';
    }
    box.innerHTML = html;
  }

  function openMiniCart() {
    ensureUI();
    closeMiniWishlist();
    var box = document.querySelector('[data-rk-mini-cart]');
    if (!box) return;
    box.hidden = false;
    box.classList.add('is-open');
    var toggle = document.querySelector('[data-rk-cart-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function closeMiniCart() {
    var box = document.querySelector('[data-rk-mini-cart]');
    if (!box) return;
    box.hidden = true;
    box.classList.remove('is-open');
    var toggle = document.querySelector('[data-rk-cart-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function renderMiniWishlist(rows, loading) {
    ensureUI();
    var box = document.querySelector('[data-rk-mini-wish]');
    if (!box) return;
    var count = (rows || []).length;
    updateWishBadge(count);

    var html = '<div class="rk-mw-head">' +
      '<div class="rk-mw-head-main">' +
        '<span class="rk-mw-head-icon" aria-hidden="true">' +
          '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>' +
        '</span>' +
        '<p class="rk-mw-head-title">Your Wishlist</p>' +
      '</div>' +
      '<p class="rk-mw-head-count">' + count + (count === 1 ? ' saved artwork' : ' saved artworks') + '</p>' +
    '</div>';

    if (loading) {
      html += '<div class="rk-mw-loading"><p>Loading saved artworks…</p></div>';
    } else if (!count) {
      html += '<div class="rk-mw-empty">' +
        '<div class="rk-mw-empty-icon" aria-hidden="true">' +
          '<svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z"/></svg>' +
        '</div>' +
        '<p class="rk-mw-empty-h">Nothing saved yet</p>' +
        '<p class="rk-mw-empty-p">Tap the heart on any artwork to save it here for later.</p>' +
        '<a class="rk-mw-btn rk-mw-btn--brass" href="' + esc(shopCollectionUrl()) + '">Browse the Shop</a>' +
      '</div>';
    } else {
      html += '<div class="rk-mw-items">';
      rows.forEach(function (row) {
        var p = row.product;
        var w = row.wish;
        if (!p) return;
        var img = p.featured_image || (p.images && p.images[0]) || '';
        var tier = tierLabelFromProduct(p);
        var url = p.url || (rootPath() + 'products/' + p.handle);
        var v = firstAvailableVariant(p);
        var price = p.price_min != null ? p.price_min : (v ? v.price : 0);
        html += '<article class="rk-mw-row">' +
          '<a class="rk-mw-thumb-link" href="' + esc(url) + '">' +
            (img ? '<img class="rk-mw-thumb" src="' + esc(img) + '" alt="" width="58" height="72" loading="lazy">' : '<div class="rk-mw-thumb rk-mw-thumb--ph"></div>') +
          '</a>' +
          '<div class="rk-mw-meta">' +
            '<span class="rk-mw-tier">' + esc(tier) + '</span>' +
            '<a class="rk-mw-title" href="' + esc(url) + '">' + esc(p.title || '') + '</a>' +
            (p.vendor ? '<p class="rk-mw-artist">' + esc(p.vendor) + '</p>' : '') +
            '<p class="rk-mw-price">From ' + money(price) + '</p>' +
            '<div class="rk-mw-row-actions">' +
              (v && v.available ? '<button type="button" class="rk-mw-act rk-mw-act--brass" data-rk-mw-atc="' + esc(String(v.id)) + '">Add to Cart</button>' : '') +
              '<button type="button" class="rk-mw-act" data-rk-mw-qv="' + esc(p.handle) + '">Quick View</button>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="rk-mw-remove" data-rk-mw-remove="' + esc(wishEntryId(w)) + '" aria-label="Remove from wishlist">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>' +
          '</button>' +
        '</article>';
      });
      html += '</div>';
      html += '<div class="rk-mw-foot">' +
        '<p class="rk-mw-note">Saved on this device · sign in to sync across devices when wishlist accounts launch.</p>' +
        '<a class="rk-mw-btn rk-mw-btn--ghost" href="' + esc(shopCollectionUrl()) + '">Continue Shopping</a>' +
      '</div>';
    }
    box.innerHTML = html;
  }

  function openMiniWishlist() {
    ensureUI();
    closeMiniCart();
    var box = document.querySelector('[data-rk-mini-wish]');
    if (!box) return;
    box.hidden = false;
    box.classList.add('is-open');
    var toggle = document.querySelector('[data-rk-wishlist-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function closeMiniWishlist() {
    var box = document.querySelector('[data-rk-mini-wish]');
    if (!box) return;
    box.hidden = true;
    box.classList.remove('is-open');
    var toggle = document.querySelector('[data-rk-wishlist-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  function fetchWishProduct(entry) {
    if (!entry.handle) return Promise.resolve(null);
    return fetch(productJs(entry.handle), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function refreshWishlist() {
    ensureUI();
    var entries = getWish();
    renderMiniWishlist([], true);
    if (!entries.length) {
      renderMiniWishlist([]);
      return Promise.resolve([]);
    }
    return Promise.all(entries.map(function (entry) {
      return fetchWishProduct(entry).then(function (product) {
        return product ? { wish: entry, product: product } : null;
      });
    })).then(function (rows) {
      var valid = rows.filter(Boolean);
      var validIds = {};
      valid.forEach(function (r) { validIds[wishEntryId(r.wish)] = true; });
      var pruned = entries.filter(function (e) { return validIds[wishEntryId(e)]; });
      if (pruned.length !== entries.length) setWish(pruned);
      renderMiniWishlist(valid, false);
      return valid;
    });
  }

  function removeWishId(id) {
    var next = getWish().filter(function (w) { return wishEntryId(w) !== String(id); });
    setWish(next);
    document.querySelectorAll('.rk-pc-wish[data-wish-id="' + id + '"]').forEach(function (btn) {
      btn.classList.remove('on');
      btn.setAttribute('aria-pressed', 'false');
    });
    var box = document.querySelector('[data-rk-mini-wish]');
    if (box && box.classList.contains('is-open')) refreshWishlist();
  }

  function refreshCart() {
    return fetch(cartUrl(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderMiniCart(cart); return cart; })
      .catch(function () { return null; });
  }

  function addToCart(variantId, qty, properties) {
    var body = { id: Number(variantId), quantity: qty || 1 };
    if (properties) body.properties = properties;
    return fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (err) { throw err; });
      return r.json();
    }).then(function () {
      return refreshCart().then(function (cart) { openMiniCart(); return cart; });
    });
  }

  /* ── A FRAME NEVER OUTLIVES ITS PRINT (15 Oct 2026) ─────────────────────────────
     A framed purchase is two lines joined by _frame_group: the print and a "Framing"
     add-on. Removing the print here left the frame in the cart — $65 for a frame with
     nothing in it. Removing either line now removes the pair, and any frame whose print
     has gone (removed on /cart, or anywhere else) is swept out. One request each. */
  function cartUpdateUrl() { return rootPath() + 'cart/update.js'; }
  function zeroLines(keys) {
    var updates = {}; keys.forEach(function (k) { updates[k] = 0; });
    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    });
  }
  function orphanFrames(cart) {
    var items = (cart && cart.items) || [], prints = {};
    items.forEach(function (it) { var g = it.properties && it.properties._frame_group; if (g && it.handle !== 'framing') prints[g] = true; });
    return items.filter(function (it) { var g = it.properties && it.properties._frame_group; return it.handle === 'framing' && g && !prints[g]; })
      .map(function (it) { return it.key; });
  }
  function sweepOrphanFrames(cart) {
    var gone = orphanFrames(cart);
    if (!gone.length) return Promise.resolve(false);
    return zeroLines(gone).then(function () { return true; }).catch(function () { return false; });
  }
  function removeLine(key) {
    return fetch(cartUrl(), { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var line = ((cart && cart.items) || []).filter(function (it) { return it.key === key; })[0];
      var g = line && line.properties && line.properties._frame_group;
      var keys = g ? cart.items.filter(function (it) { return it.properties && it.properties._frame_group === g; }).map(function (it) { return it.key; }) : [key];
      if (keys.indexOf(key) === -1) keys.push(key);
      return zeroLines(keys);
    }).catch(function () {
      return fetch(changeUrl(), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    }).then(function () { return refreshCart(); }).then(function (cart) {
      return sweepOrphanFrames(cart).then(function (did) { return did ? refreshCart() : cart; });
    }).then(function (cart) {
      try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (e) {}
      return cart;
    });
  }

  function tierMeta(slug) { return TIER_META[slug] || TIER_META.open; }

  function normOpt(s) {
    return String(s || '')
      .toLowerCase()
      .replace(/\s+/g, '')
      .replace(/["″“”']/g, '')
      .replace(/×/g, 'x')
      .replace(/-/g, '');
  }

  function optsMatch(a, b) {
    var na = normOpt(a);
    var nb = normOpt(b);
    if (!na || !nb) return !na && !nb;
    return na === nb || na.indexOf(nb) !== -1 || nb.indexOf(na) !== -1;
  }

  function isMountedFinish(label) {
    var s = String(label || '').toLowerCase();
    if (
      s.indexOf('unframed') !== -1 ||
      s.indexOf('print only') !== -1 ||
      s.indexOf('print-only') !== -1 ||
      s.indexOf('none') !== -1 ||
      s.indexOf('no frame') !== -1
    ) {
      return false;
    }
    return s.indexOf('mount') !== -1 || s.indexOf('frameless') !== -1 || s.indexOf('framed') !== -1;
  }

  function formatSizeLabel(raw) {
    var s = String(raw == null ? '' : raw).trim();
    if (!s) return { primary: s, alt: '' };
    var primary = s;
    var alt = '';
    if (/inch/i.test(s)) {
      s.split(',').forEach(function (chunk) {
        var c = chunk.trim();
        var lc = c.toLowerCase();
        if (lc.indexOf('inch') !== -1) {
          primary = c
            .replace(/inches?/gi, '"')
            .replace(/\.0"/g, '"')
            .replace(/\s+/g, '')
            .replace(/"x/gi, 'x');
          if (primary.indexOf('"') === -1) primary += '"';
        } else if (lc.indexOf('cm') !== -1) {
          alt = c.replace(/\s+/g, ' ').trim();
        }
      });
    }
    // Frame Up style: 16x20" → 16 x 20"
    primary = primary.replace(/[×X]/g, 'x');
    var m = primary.match(/^(\d+(?:\.\d+)?)\s*x\s*(\d+(?:\.\d+)?)("?)$/i);
    if (m) primary = m[1] + ' x ' + m[2] + (m[3] || '');
    return { primary: primary, alt: alt };
  }

  function formatFinishLabel(raw) {
    var s = String(raw == null ? '' : raw).trim();
    var lc = s.toLowerCase();
    if (lc === 'print only' || lc === 'print-only' || lc === 'none' || lc === 'no frame' || lc === 'unframed') return 'Museum-Quality Print only';
    return s;
  }

  function sizeLabelHtml(raw) {
    var fmt = formatSizeLabel(raw);
    var html = esc(fmt.primary);
    if (fmt.alt) html += '<span class="rk-sz-alt">' + esc(fmt.alt) + '</span>';
    return html;
  }

  function productOptionEntries(p) {
    var raw = (p && p.options) || [];
    var out = [];
    for (var i = 0; i < raw.length; i++) {
      var o = raw[i];
      if (typeof o === 'string') {
        out.push({ name: o, values: uniqueVariantOption(p, i) });
      } else if (o && o.name) {
        out.push({
          name: o.name,
          values: (o.values && o.values.length) ? o.values.slice() : uniqueVariantOption(p, i)
        });
      }
    }
    return out;
  }

  function uniqueVariantOption(p, index) {
    var seen = {};
    var vals = [];
    var vs = (p && p.variants) || [];
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      var raw = '';
      if (v.options && v.options[index] != null) raw = v.options[index];
      else if (index === 0) raw = v.option1;
      else if (index === 1) raw = v.option2;
      else if (index === 2) raw = v.option3;
      var s = raw == null ? '' : String(raw);
      if (!s || seen[s]) continue;
      seen[s] = true;
      vals.push(s);
    }
    return vals;
  }

  function findOptionIndex(entries, names) {
    for (var i = 0; i < entries.length; i++) {
      var n = String(entries[i].name || '').toLowerCase();
      for (var j = 0; j < names.length; j++) {
        var want = names[j].toLowerCase();
        if (n === want || n.indexOf(want) !== -1) return i;
      }
    }
    return -1;
  }

  function sizeValues(p) {
    var entries = productOptionEntries(p);
    var idx = findOptionIndex(entries, ['size', 'paper size', 'print size']);
    if (idx >= 0 && entries[idx].values.length) return entries[idx].values;
    if (entries.length) return entries[0].values || uniqueVariantOption(p, 0);
    return uniqueVariantOption(p, 0);
  }

  /**
   * MOUNT FEES FOR PRODUCTS THAT DO NOT SELL A FINISH OPTION.
   *
   * Only 7 of 66 products sell Finish as a variant. The product page still offers
   * Frameless Mounted on the other 59, as a per-size FEE carried on the line as a
   * Finish property - see `default_mount_fees` in sections/rk-pdp-open.liquid, which is
   * where these numbers come from and where they must stay in step.
   *
   * Quick View built its finish list from variant options ALONE, so on those 59 it fell
   * through to the hardcoded Unframed button below and silently dropped Frameless
   * Mounted - the one finish that costs money. The only way to find it was "View full
   * product details".
   *
   * Indexed by SIZE position, exactly as the Liquid does, last fee standing in beyond
   * the end of the table.
   */
  var RK_MOUNT_FEES = [2500, 4500, 7500, 10000];
  function mountFeeCents(sizeIdx) {
    var i = sizeIdx >= 0 ? sizeIdx : 0;
    return RK_MOUNT_FEES[i] != null ? RK_MOUNT_FEES[i] : RK_MOUNT_FEES[RK_MOUNT_FEES.length - 1];
  }

  function finishValues(p) {
    var entries = productOptionEntries(p);
    var idx = findOptionIndex(entries, ['finish', 'frame', 'framing', 'mount']);
    if (idx < 0) return [];
    return entries[idx].values || [];
  }

  function variantOptionAt(v, index) {
    if (!v) return '';
    if (v.options && v.options[index] != null) return String(v.options[index]);
    if (index === 0) return String(v.option1 || '');
    if (index === 1) return String(v.option2 || '');
    if (index === 2) return String(v.option3 || '');
    return '';
  }

  function optionIndexes(p) {
    var entries = productOptionEntries(p);
    var sizeIdx = findOptionIndex(entries, ['size', 'paper size', 'print size']);
    var finishIdx = findOptionIndex(entries, ['finish', 'frame', 'framing', 'mount']);
    if (sizeIdx < 0) sizeIdx = 0;
    return { sizeIdx: sizeIdx, finishIdx: finishIdx };
  }

  function findVariant(sizeLabel, finishLabel) {
    var p = state.product;
    if (!p || !p.variants || !p.variants.length) return null;
    var idx = optionIndexes(p);
    var hasFin = idx.finishIdx >= 0;
    var sizeLc = sizeLabel || state.sizeLabel;
    var finLc = finishLabel || state.finishLabel;
    var fallback = null;

    for (var i = 0; i < p.variants.length; i++) {
      var v = p.variants[i];
      var sz = variantOptionAt(v, idx.sizeIdx);
      var fr = hasFin ? variantOptionAt(v, idx.finishIdx) : '';
      var sizeOk = !sizeLc || optsMatch(sz, sizeLc) || optsMatch(v.title, sizeLc);
      if (!sizeOk) continue;
      if (!hasFin) return v;
      var finOk =
        !finLc ||
        optsMatch(fr, finLc) ||
        (isMountedFinish(finLc) && isMountedFinish(fr)) ||
        (!isMountedFinish(finLc) && !isMountedFinish(fr));
      if (finOk) return v;
      if (!fallback) fallback = v;
    }
    return fallback || p.variants[0];
  }

  function initSelectionFromProduct(p) {
    var sizes = sizeValues(p);
    var finishes = finishValues(p);
    var first = null;
    var vs = p.variants || [];
    for (var i = 0; i < vs.length; i++) {
      if (vs[i].available) { first = vs[i]; break; }
    }
    if (!first) first = vs[0] || null;
    var idx = optionIndexes(p);
    if (first) {
      state.sizeLabel = variantOptionAt(first, idx.sizeIdx) || (sizes[0] || '') || (first.title !== 'Default Title' ? first.title : '');
      state.finishLabel = idx.finishIdx >= 0
        ? (variantOptionAt(first, idx.finishIdx) || finishes[0] || 'Unframed')
        : (finishes[0] || '');
    } else {
      state.sizeLabel = sizes[0] || '';
      state.finishLabel = finishes[0] || '';
    }
  }

  function currentVariant() {
    return findVariant(state.sizeLabel, state.finishLabel);
  }

  function currentPriceCents() {
    var v = currentVariant();
    return v ? Number(v.price) : Number(state.card && state.card.price) || 0;
  }

  function klarnaOsmReady() {
    return !!(
      window.Klarna ||
      window.KlarnaOnsiteService ||
      document.querySelector('script[src*="js.klarna.com"], script[src*="klarna.com/"]')
    );
  }

  function refreshKlarnaOsm() {
    try {
      if (window.Klarna && Klarna.OnsiteMessaging && typeof Klarna.OnsiteMessaging.refresh === 'function') {
        Klarna.OnsiteMessaging.refresh();
        return;
      }
      if (window.KlarnaOnsiteService && typeof window.KlarnaOnsiteService.refreshPlacements === 'function') {
        window.KlarnaOnsiteService.refreshPlacements();
      }
    } catch (err) {}
  }

  function markPayMount(mount, hasContent) {
    if (!mount) return;
    mount.classList.toggle('is-empty', !hasContent);
    mount.hidden = !hasContent;
    var row = mount.previousElementSibling;
    if (row && row.classList.contains('rk-qv-price-row')) {
      row.classList.toggle('has-meta', !hasContent);
    }
  }

  function syncPaymentTerms(handle, variantId, priceCents) {
    var mount = document.querySelector('[data-rk-qv-pay]');
    if (!mount || !handle) return;
    var req = ++state.payReq;
    var cents = Math.max(0, Math.round(Number(priceCents) || 0));
    var vid = variantId ? String(variantId) : '';

    // Prefer live Klarna OSM when the app is installed — real offers for this amount
    if (klarnaOsmReady()) {
      mount.innerHTML =
        '<klarna-placement data-key="credit-promotion-auto-size" data-locale="en-US" data-purchase-amount="' +
        esc(String(cents)) +
        '"></klarna-placement>';
      markPayMount(mount, true);
      refreshKlarnaOsm();
      return;
    }

    // Else Shopify payment_terms (Shop Pay Installments / eligible BNPL from Admin)
    var url =
      rootPath() +
      'products/' +
      encodeURIComponent(handle) +
      '?section_id=rk-qv-payment-terms' +
      (vid ? '&variant=' + encodeURIComponent(vid) : '');

    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('pay-terms');
        return r.text();
      })
      .then(function (html) {
        if (req !== state.payReq) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var terms = doc.querySelector('[data-rk-qv-pay-terms]') || doc.querySelector('shopify-payment-terms');
        if (!terms) {
          mount.innerHTML = '';
          markPayMount(mount, false);
          return;
        }
        mount.innerHTML = '';
        mount.appendChild(document.importNode(terms, true));
        var elPay = mount.querySelector('shopify-payment-terms');
        if (elPay && vid) {
          elPay.setAttribute('variant-id', vid);
        }
        var has =
          !!elPay ||
          !!(mount.textContent || '').trim() ||
          !!mount.querySelector('[data-rk-qv-pay-terms] *');
        markPayMount(mount, has);

        if (!has && elPay) {
          window.setTimeout(function () {
            if (req !== state.payReq) return;
            var filled = !!(elPay.textContent || '').trim() || elPay.childNodes.length > 0;
            markPayMount(mount, filled);
          }, 600);
        }
      })
      .catch(function () {
        if (req !== state.payReq) return;
        mount.innerHTML = '';
        markPayMount(mount, false);
      });
  }

  function sizeChipPriceCents(sizeLabel) {
    var fin = state.finishLabel || (finishValues(state.product)[0] || '');
    var v = findVariant(sizeLabel, fin || 'Unframed');
    if (!v && fin) v = findVariant(sizeLabel, 'Unframed');
    return v ? Number(v.price) : 0;
  }

  function productImageList(p, card) {
    var list = [];
    var seen = {};
    function push(src) {
      src = String(src || '').trim();
      if (!src || seen[src]) return;
      seen[src] = true;
      list.push(src);
    }
    if (p) {
      push(p.featured_image);
      (p.images || []).forEach(function (img) {
        push(typeof img === 'string' ? img : (img && img.src));
      });
    }
    if (card && card.image) push(card.image);
    return list;
  }

  function artboxDims(card, framed) {
    var aspMap = {
      '4:5': { p: 1.25, l: 0.8 },
      '3:4': { p: 1.333, l: 0.75 },
      '2:3': { p: 1.5, l: 0.667 },
      '1:1': { p: 1, l: 1 }
    };
    var ratio = (card && card.ratio) || '';
    if (!ratio && state.sizeLabel) {
      ratio = ratioFromSize(state.sizeLabel, card && card.orient);
    }
    var orient = ((card && card.orient) || '').toLowerCase();
    var landscape = orient.indexOf('landscape') !== -1;
    var map = aspMap[ratio] || { p: 1.25, l: 0.8 };
    var asp = landscape ? map.l : map.p;
    var aw;
    var ah;
    if (landscape) {
      aw = 88;
      ah = +(88 * asp).toFixed(1);
    } else {
      aw = +(88 / asp).toFixed(1);
      ah = 88;
    }
    if (framed) {
      aw = +(aw * 0.86).toFixed(1);
      ah = +(ah * 0.86).toFixed(1);
    }
    return { width: aw, height: ah };
  }

  function artboxStyle(card, framed) {
    var d = artboxDims(card, framed);
    return ' style="width:' + d.width + '%;height:' + d.height + '%"';
  }

  function buildMediaSlots(p, card) {
    var images = productImageList(p, card);
    var primary = images[0] || '';
    var slots = [
      { type: 'artwork', src: primary, label: 'Artwork' },
      { type: 'room', src: primary, label: 'In Room' },
      { type: 'detail', src: primary, label: 'Detail' },
      { type: 'texture', src: primary, label: 'Texture' }
      /* §4.5: Mounted is discontinued — its media slot is retired. */
    ];
    if (images.length > 1) slots[2] = { type: 'detail', src: images[1], label: 'Detail' };
    if (images.length > 2) slots[3] = { type: 'image', src: images[2], label: 'View' };
    return slots.slice(0, 6);
  }

  function slideHtml(slot, index, active) {
    var on = active ? ' on' : '';
    var src = esc(slot.src || '');
    var orient = ((state.card && state.card.orient) || '').toLowerCase();
    var landscape = orient.indexOf('landscape') !== -1;
    var framed = state.framePreview;
    var mounted = state.finishLabel && isMountedFinish(state.finishLabel);

    if (slot.type === 'artwork') {
      var artStyle = artboxStyle(state.card, framed);
      return (
        '<div class="rk-qv-slide rk-qv-slide--artwork' + on + (framed ? ' is-framed' : '') + '" data-rk-qv-slide="' + index + '">' +
        (framed
          ? '<div class="rk-qv-artbox rk-qv-artbox--framed"' + artStyle + '><div class="rk-qv-artbox__inner"><img src="' + src + '" alt=""></div></div>' +
            '<p class="rk-qv-slide-cap">Framed preview — black gallery frame · archival mat</p>'
          : '<div class="rk-qv-artbox"' + artStyle + '><img src="' + src + '" alt=""></div>') +
        '</div>'
      );
    }
    if (slot.type === 'room') {
      return (
        '<div class="rk-qv-slide rk-qv-slide--room' + on + (landscape ? ' is-landscape' : '') + (mounted ? ' is-mounted' : '') + (framed ? ' is-framed' : '') + '" data-rk-qv-slide="' + index + '">' +
        '<div class="rk-qv-room-bg"></div>' +
        '<div class="rk-qv-room-print"><img src="' + src + '" alt=""></div>' +
        '<p class="rk-qv-slide-cap">' + (framed ? 'In room · framed preview' : 'In room · to scale') + '</p>' +
        '</div>'
      );
    }
    if (slot.type === 'detail') {
      return (
        '<div class="rk-qv-slide rk-qv-slide--detail' + on + '" data-rk-qv-slide="' + index + '">' +
        '<div class="rk-qv-detail-zoom"><img src="' + src + '" alt=""></div>' +
        '</div>'
      );
    }
    if (slot.type === 'texture') {
      var tier = tierMeta((state.card && state.card.tier) || 'open');
      return (
        '<div class="rk-qv-slide rk-qv-slide--texture' + on + '" data-rk-qv-slide="' + index + '">' +
        '<div class="rk-qv-texture-zoom"><img src="' + src + '" alt=""></div>' +
        '<div class="rk-qv-texture-grain" aria-hidden="true"></div>' +
        '<p class="rk-qv-slide-cap rk-qv-slide-cap--texture">' + esc(tier.paperLabel) + ' surface</p>' +
        '</div>'
      );
    }
    if (slot.type === 'mounted') {
      return (
        '<div class="rk-qv-slide rk-qv-slide--mounted' + on + '" data-rk-qv-slide="' + index + '">' +
        '<div class="rk-qv-mounted-bg"></div>' +
        '<div class="rk-qv-mounted-print"><img src="' + src + '" alt=""></div>' +
        '<p class="rk-qv-slide-cap">Frameless Mounted · 3mm Dibond, floats 8mm off the wall</p>' +
        '</div>'
      );
    }
    return (
      '<div class="rk-qv-slide rk-qv-slide--image' + on + '" data-rk-qv-slide="' + index + '">' +
      '<img src="' + src + '" alt="">' +
      '</div>'
    );
  }

  function thumbHtml(slot, index, active) {
    var src = esc(slot.src || '');
    var on = active ? ' on' : '';
    return (
      '<button type="button" class="rk-qv-th' + on + '" data-rk-qv-thumb="' + index + '" role="tab" aria-selected="' + (active ? 'true' : 'false') + '" aria-label="' + esc(slot.label) + '">' +
      '<span class="rk-qv-th__inner">' +
      (slot.type === 'detail'
        ? '<span class="rk-qv-th__zoom"><img src="' + src + '" alt=""></span>'
        : '<img src="' + src + '" alt="">') +
      '</span></button>'
    );
  }

  function setMediaIndex(index) {
    var slots = state.mediaSlots || [];
    if (!slots.length) return;
    var n = slots.length;
    state.mediaIndex = ((index % n) + n) % n;
    renderMediaGallery();
  }

  function renderMediaGallery() {
    var slotsEl = document.querySelector('[data-rk-qv-media-slots]');
    var thumbsEl = document.querySelector('[data-rk-qv-thumbs]');
    var countEl = document.querySelector('[data-rk-qv-count]');
    var stage = document.querySelector('[data-rk-qv-stage]');
    if (!slotsEl || !thumbsEl) return;

    var slots = buildMediaSlots(state.product, state.card);
    state.mediaSlots = slots;
    if (state.mediaIndex >= slots.length) state.mediaIndex = 0;

    var slidesHtml = '';
    var thumbsHtml = '';
    slots.forEach(function (slot, i) {
      var active = i === state.mediaIndex;
      slidesHtml += slideHtml(slot, i, active);
      thumbsHtml += thumbHtml(slot, i, active);
    });
    slotsEl.innerHTML = slidesHtml;
    thumbsEl.innerHTML = thumbsHtml;
    if (countEl) countEl.textContent = slots.length ? state.mediaIndex + 1 + ' / ' + slots.length : '';
    if (stage && slots.length) {
      stage.setAttribute(
        'aria-label',
        'Media ' + (state.mediaIndex + 1) + ' of ' + slots.length + ' — ' + slots[state.mediaIndex].label
      );
    }
  }

  function setTab(tab) {
    state.tab = tab;
    var map = { artwork: 0, room: 1, detail: 2, texture: 3, mounted: 4 };
    if (map[tab] != null) setMediaIndex(map[tab]);
  }

  function shippingLineHtml(priceCents, mounted) {
    /* §4.9: $15 / $25 / $35 by size; free on orders of $150 or more. Mounted is discontinued. */
    var free = priceCents >= SHIP_FREE_CENTS;
    return '<p class="rk-qv-ship' + (free ? ' is-free' : '') + '">' +
      (free ? '✓ Free US shipping' : 'US shipping $15–$35 by size · free on orders of $150 or more') +
      '</p>';
  }

  function cardImageUrl(card) {
    if (!card) return '';
    var fromData = card.getAttribute && card.getAttribute('data-image');
    if (fromData) return fromData;
    if (card.image) return card.image;
    var imgEl = card.querySelector && card.querySelector('.rk-pci-img');
    if (!imgEl) return '';
    var src = imgEl.currentSrc || imgEl.getAttribute('src') || '';
    if (src) return src;
    var srcset = imgEl.getAttribute('srcset') || '';
    if (!srcset) return '';
    var parts = srcset.split(',').map(function (p) { return p.trim().split(/\s+/)[0]; }).filter(Boolean);
    return parts.length ? parts[parts.length - 1] : '';
  }

  function parseSpaces(raw) {
    if (!raw) return [];
    return String(raw).split(/[|,]/).map(function (s) { return s.replace(/\s+/g, ' ').trim(); }).filter(Boolean);
  }

  function readCardMeta(cardEl) {
    if (!cardEl) return null;
    var special = cardEl.getAttribute('data-special-tags') || '';
    var sellingFast =
      cardEl.getAttribute('data-selling-fast') === '1' ||
      /(^|,)\s*selling[- ]?fast\s*(,|$)/i.test(special) ||
      !!(cardEl.querySelector && cardEl.querySelector('.rk-pc-urg-pill') &&
        /selling\s*fast/i.test(cardEl.querySelector('.rk-pc-urg-pill').textContent || ''));
    return {
      tier: cardEl.getAttribute('data-tier') || 'open',
      tierLabel: cardEl.getAttribute('data-tier-label') || '',
      heritage: cardEl.getAttribute('data-heritage') || '',
      heritageLabel: cardEl.getAttribute('data-heritage-label') || '',
      artist: cardEl.getAttribute('data-artist') || '',
      artistLoc: cardEl.getAttribute('data-artist-location') || '',
      year: cardEl.getAttribute('data-year') || '',
      style: cardEl.getAttribute('data-style') || '',
      subject: cardEl.getAttribute('data-subject') || '',
      colour: cardEl.getAttribute('data-colour') || '',
      orient: cardEl.getAttribute('data-orient') || '',
      ratio: cardEl.getAttribute('data-ratio') || '',
      space: cardEl.getAttribute('data-space') || '',
      note: cardEl.getAttribute('data-note') || '',
      price: cardEl.getAttribute('data-price') || '0',
      badge: cardEl.getAttribute('data-badge') || '',
      editionTotal: cardEl.getAttribute('data-edition-total') || '',
      editionRemaining: cardEl.getAttribute('data-edition-remaining') || '',
      rating: cardEl.getAttribute('data-rating') || '',
      reviews: cardEl.getAttribute('data-reviews') || '',
      sellingFast: sellingFast,
      image: cardImageUrl(cardEl),
      title: cardEl.getAttribute('data-title') || '',
      handle: cardEl.getAttribute('data-handle') || ''
    };
  }

  function gcd(a, b) {
    a = Math.abs(a);
    b = Math.abs(b);
    while (b) {
      var t = b;
      b = a % b;
      a = t;
    }
    return a || 1;
  }

  function ratioFromSize(sizeLabel, orient) {
    var m = String(sizeLabel || '').match(/(\d+(?:\.\d+)?)\s*[×x]\s*(\d+(?:\.\d+)?)/i);
    if (!m) return '';
    var w = Math.round(parseFloat(m[1]));
    var h = Math.round(parseFloat(m[2]));
    if (!w || !h) return '';
    if (orient && /landscape/i.test(orient) && w < h) {
      var swap = w;
      w = h;
      h = swap;
    }
    var g = gcd(w, h);
    return w / g + ':' + h / g;
  }

  function starsHtml(rating) {
    var r = parseFloat(rating);
    if (isNaN(r) || r <= 0) return '';
    var full = Math.floor(r);
    var half = r - full >= 0.5;
    var html = '<span class="rk-qv-stars" aria-hidden="true">';
    for (var i = 0; i < 5; i++) {
      var fill = i < full ? 'full' : i === full && half ? 'half' : 'empty';
      html += '<span class="rk-qv-star rk-qv-star--' + fill + '"></span>';
    }
    html += '</span>';
    return html;
  }

  function isWoodFramedFinish(label) {
    var s = String(label || '').toLowerCase();
    return s.indexOf('framed') !== -1 && s.indexOf('frameless') === -1 && s.indexOf('unframed') === -1;
  }

  function resolveShopCardEl(handle, cardEl) {
    if (cardEl && cardEl.getAttribute && cardEl.getAttribute('data-handle')) return cardEl;
    if (!handle) return cardEl || null;
    var escHandle = String(handle).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    var selectors = [
      '#rk-shop-grid .rk-pc[data-handle="' + escHandle + '"]',
      '[data-rk-grid] .rk-pc[data-handle="' + escHandle + '"]',
      '[data-rk-ap-works-grid] .rk-pc[data-handle="' + escHandle + '"]',
      '.rk-feat .rk-pc[data-handle="' + escHandle + '"]',
      '.rk-pc[data-handle="' + escHandle + '"]',
      '.rk-tp-pick-tile[data-handle="' + escHandle + '"]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var found = document.querySelector(selectors[i]);
      if (found) return found;
    }
    return cardEl || null;
  }

  function qvCardVisible(card) {
    if (!card) return false;
    if (card.hidden) return false;
    if (card.classList && card.classList.contains('is-hidden')) return false;
    if (card.classList && (card.classList.contains('rk-pc--ph') || card.classList.contains('rk-pc--fill'))) return false;
    return true;
  }

  function shopGridCardEls() {
    var selectors = [
      '#rk-shop-grid .rk-pc[data-handle]',
      '[data-rk-grid] .rk-pc[data-handle]',
      '[data-rk-ap-works-grid] .rk-pc[data-handle]',
      '.rk-feat .rk-pc[data-handle]',
      '.rk-pc[data-handle]'
    ];
    var seen = {};
    var out = [];
    function pushCard(el) {
      if (!el || !el.getAttribute) return;
      var h = el.getAttribute('data-handle');
      if (!h || seen[h]) return;
      if (el.classList && (el.classList.contains('rk-pc--ph') || el.classList.contains('rk-pc--fill'))) return;
      seen[h] = true;
      out.push(el);
    }
    for (var i = 0; i < selectors.length; i++) {
      Array.prototype.forEach.call(document.querySelectorAll(selectors[i]), pushCard);
      if (out.length) break;
    }
    // Homepage / sparse pages: merge every product card on the page
    if (out.length && out.length < 8) {
      Array.prototype.forEach.call(document.querySelectorAll('.rk-pc[data-handle]'), pushCard);
    }
    return out;
  }

  function shopCatalogItems() {
    var el = document.querySelector('[id^="rk-sg-catalog-"]');
    if (!el) return [];
    try {
      var data = JSON.parse(el.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (e) {
      return [];
    }
  }

  function pairThumbHtml(c) {
    var url = cardImageUrl(c);
    if (url) return '<img src="' + esc(url) + '" alt="">';
    var tier = ((c.getAttribute && c.getAttribute('data-tier')) || c.tier || 'open').replace(/[^a-z0-9-]/gi, '') || 'open';
    return '<div class="rk-pci-ph rk-pci-ph--' + esc(tier) + '" aria-hidden="true"></div>';
  }

  function pairScore(current, candidate) {
    if (!candidate || candidate.handle === current.handle) return -1;
    var score = 0;
    if (current.heritage && candidate.heritage && current.heritage === candidate.heritage) score += 3;
    var a = parseSpaces(current.space);
    var b = parseSpaces(candidate.space);
    for (var i = 0; i < a.length; i++) {
      if (b.indexOf(a[i]) !== -1) { score += 2; break; }
    }
    if (current.artist && candidate.artist && current.artist === candidate.artist) score += 1;
    return score;
  }

  function pairsHtml() {
    var handle = state.product && state.product.handle;
    if (!handle) return '';

    var card = state.card || {};
    var current = {
      handle: handle,
      heritage: card.heritage || '',
      space: card.space || '',
      artist: card.artist || ''
    };

    var domCards = shopGridCardEls();
    var visible = domCards.filter(qvCardVisible);
    var poolEls = visible.length > 1 ? visible : domCards;

    var ranked = [];
    poolEls.forEach(function (el) {
      var h = el.getAttribute('data-handle');
      if (!h || h === handle) return;
      var meta = {
        handle: h,
        heritage: el.getAttribute('data-heritage') || '',
        space: el.getAttribute('data-space') || '',
        artist: el.getAttribute('data-artist') || '',
        title: el.getAttribute('data-title') || '',
        price: el.getAttribute('data-price') || '0',
        el: el
      };
      var s = pairScore(current, meta);
      if (s >= 0) ranked.push({ s: s, item: meta });
    });

    if (ranked.length < 4) {
      var seen = {};
      ranked.forEach(function (r) { seen[r.item.handle] = true; });
      shopCatalogItems().forEach(function (row) {
        if (!row || !row.handle || row.handle === handle || seen[row.handle]) return;
        var meta = {
          handle: row.handle,
          heritage: row.heritage || '',
          space: row.space || '',
          artist: row.artist || '',
          title: row.title || '',
          price: row.price || 0,
          image: row.image || ''
        };
        var s = pairScore(current, meta);
        if (s >= 0) {
          ranked.push({ s: Math.max(s, 1), item: meta });
          seen[row.handle] = true;
        }
      });
    }

    ranked.sort(function (a, b) { return b.s - a.s; });
    var matches = ranked.slice(0, 4).map(function (r) { return r.item; });
    if (!matches.length) {
      matches = poolEls
        .map(function (el) {
          return {
            handle: el.getAttribute('data-handle'),
            title: el.getAttribute('data-title') || '',
            price: el.getAttribute('data-price') || '0',
            el: el
          };
        })
        .filter(function (m) { return m.handle && m.handle !== handle; })
        .slice(0, 4);
    }
    if (!matches.length) return '';

    var html = '<div class="rk-qv-pairs"><p class="rk-qv-lab">Pairs Well With</p><div class="rk-qv-pairs-row">';
    matches.forEach(function (m) {
      html += '<button type="button" class="rk-qv-pair" data-rk-qv-pair="' + esc(m.handle) + '">' +
        '<div class="rk-qv-pair-img">' + pairThumbHtml(m.el || m) + '</div>' +
        '<p class="rk-qv-pair-title">' + esc(displayTitle(null, m)) + '</p>' +
        '<p class="rk-qv-pair-price">From ' + money(m.price) + '</p>' +
      '</button>';
    });
    html += '</div></div>';
    return html;
  }

  function displayTitle(product, card) {
    var raw = (card && card.title) || (product && product.title) || '';
    raw = String(raw).trim();
    if (!raw) return '';
    // Prefer the artwork name when Shopify titles are "Name — Artist" / "Name | Artist"
    var parts = raw.split(/\s+[—–|\-]\s+/);
    if (parts.length > 1 && parts[0].length >= 3) return parts[0].trim();
    return raw;
  }

  function renderQVBody() {
    var p = state.product;
    var card = state.card || {};
    if (!p) return;
    var scroll = document.querySelector('[data-rk-qv-scroll]');
    var atc = document.querySelector('[data-rk-qv-atc]');
    var wish = document.querySelector('[data-rk-qv-wish]');
    if (!scroll) return;

    var tier = card.tier || 'open';
    var meta = tierMeta(tier);
    var sizes = sizeValues(p);
    var realFinishes = finishValues(p).filter(function (fin) {
      return !isWoodFramedFinish(fin);
    });
    /* No Finish option on the product: offer the same pair the product page does. */
    var synthFin = realFinishes.length === 0;
    var finishes = synthFin ? ['Unframed'] : realFinishes;
    var sizeLabel = state.sizeLabel || (sizes[0] || '') || 'One size';
    var finishLabel = state.framePreview ? '' : (state.finishLabel || finishes[0] || '');
    if (!state.framePreview && isWoodFramedFinish(finishLabel)) {
      finishLabel = finishes[0] || '';
      state.finishLabel = finishLabel;
    }
    // Resolve price AFTER size/finish are known (was previously reading undeclared vars)
    var priceFinish = state.framePreview
      ? (finishes[0] || 'Unframed')
      : (finishLabel || finishes[0] || 'Unframed');
    var v = findVariant(sizeLabel, priceFinish) || currentVariant() || firstAvailableVariant(p);
    var price = v ? Number(v.price) : Number(card.price) || 0;
    /* A synthesised finish has no variant of its own, so the variant price IS the
       Unframed price and the mount fee goes on top - finishAddonCents does the same on
       the product page. */
    var sizeIdx = sizes.indexOf(sizeLabel);
    if (synthFin && !state.framePreview && isMountedFinish(finishLabel)) {
      price += mountFeeCents(sizeIdx);
    }
    var hasFin = finishes.length > 0;
    var title = displayTitle(p, card);
    var heritage = card.heritageLabel || card.heritage || '';
    var artist = card.artist || p.vendor || '';
    var year = card.year || '';
    var style = card.style || '';
    var spaces = (card.space || '').split(/[|,]/).map(function (s) { return s.trim(); }).filter(Boolean);
    var ratio =
      card.ratio ||
      ratioFromSize(sizeLabel, card.orient) ||
      ratioFromSize(card.size || '', card.orient);
    var mounted = !state.framePreview && hasFin && isMountedFinish(finishLabel);
    var finishDisplay = state.framePreview
      ? 'framed preview'
      : 'print only';

    var edHtml = '';
    if (tier === 'limited' || tier === 'collector') {
      var edBits = [];
      if (card.badge) edBits.push(card.badge);
      else if (tier === 'limited') edBits.push('LTD. ED.');
      else edBits.push('COLLECTOR');
      if (card.editionRemaining) edBits.push(card.editionRemaining + ' remaining');
      edHtml =
        '<span class="rk-qv-ed is-' +
        (tier === 'limited' ? 'le' : 'co') +
        '"><i></i>' +
        esc(edBits.join(' · ')) +
        '</span>';
    }

    var sizesHtml = '';
    if (sizes.length) {
      var sizeLab = 'Size';
      if (ratio) sizeLab += ' · ' + ratio + ' ratio';
      if (card.orient) sizeLab += ' · ' + card.orient;
      sizesHtml = '<div class="rk-qv-sizes-wrap"><p class="rk-qv-lab">' + esc(sizeLab) + '</p><div class="rk-qv-sizes rk-qv-szrow">';
      sizes.forEach(function (sz) {
        var szV = findVariant(sz, finishLabel || 'Unframed');
        var available = !szV || szV.available !== false;
        sizesHtml += '<button type="button" class="rk-qv-sz' + (optsMatch(sz, sizeLabel) ? ' on' : '') +
          '" data-rk-qv-size="' + esc(sz) + '" title="' + esc(sz) + '"' + (available ? '' : ' disabled style="opacity:.4"') + '>' +
          '<span class="rk-qv-sz-dim">' + sizeLabelHtml(sz) + '</span>' +
          '<span class="rk-qv-sz-price">' + money(sizeChipPriceCents(sz)) + '</span></button>';
      });
      sizesHtml += '</div></div>';
    }

    var mountedNote = 'The print bonded to a 3mm Dibond aluminium composite panel with a flush edge — no visible frame, no glazing. Hidden French-cleat hanging floats the panel 8mm off the wall.' +
      (tier === 'limited' ? ' Includes a museum-grade UV-protective archival sealant on the artwork surface (Limited Edition only).' : '') +
      ' Free US shipping included.';
    var unframedNote = 'The fine art print on its own, inside its white border, ready for your own framer.';
    var framedNote = 'Framed in solid wood with a 1-inch white mat and clear acrylic, hanging hardware installed — choose Framed on the product page.';
    var finishNote = state.framePreview
      ? framedNote
      : (!hasFin || !isMountedFinish(finishLabel) ? unframedNote : mountedNote);

    var finishHtml = '<div class="rk-qv-finish"><p class="rk-qv-lab rk-qv-lab--fin">Choose Finish' +
        '<button type="button" class="rk-qv-fin-info' + (state.finInfoOpen ? ' is-on' : '') + '" data-rk-qv-fin-info aria-label="About finishes" aria-expanded="' + (state.finInfoOpen ? 'true' : 'false') + '">i</button></p>' +
        '<div class="rk-qv-finish-opts" role="radiogroup" aria-label="Finish">';
    if (hasFin) {
      finishes.forEach(function (fin) {
        var finMounted = isMountedFinish(fin);
        /* No swatch on a plain print. sections/rk-pdp-open.liquid skips the dot for
           'unframed' and 'print only'; Quick View drew an empty outlined box there, and
           the selected-state dot inside it, which the product page never shows. */
        var finPlain = /unframed|print[\s-]?only/i.test(fin);
        var finV = findVariant(sizeLabel, fin);
        var plainV = findVariant(sizeLabel, 'Unframed') || findVariant(sizeLabel, 'Print only');
        var delta = synthFin
          ? (finMounted ? mountFeeCents(sizeIdx) : 0)
          : ((finV && plainV) ? Math.max(0, Number(finV.price) - Number(plainV.price)) : 0);
        var metaLabel = finMounted ? ('+' + dollars(delta / 100)) : 'Included';
        var isOn = !state.framePreview && optsMatch(fin, finishLabel);
        finishHtml += '<button type="button" class="rk-qv-fin' + (isOn ? ' on' : '') +
          '" data-rk-qv-finish="' + esc(fin) + '" role="radio" aria-checked="' + (isOn ? 'true' : 'false') + '">' +
          (finPlain ? '' : '<span class="rk-qv-fin-sw' + (finMounted ? ' is-mounted' : '') + '"></span>') + '<span><span class="rk-qv-fin-name">' + esc(formatFinishLabel(fin)) + '</span>' +
          '<span class="rk-qv-fin-meta' + (finMounted ? ' is-fee' : '') + '">' + metaLabel + '</span></span></button>';
      });
    } else {
      finishHtml += '<button type="button" class="rk-qv-fin' + (!state.framePreview ? ' on' : '') +
        '" data-rk-qv-finish="Unframed" role="radio" aria-checked="' + (!state.framePreview ? 'true' : 'false') + '">' +
        '<span><span class="rk-qv-fin-name">Unframed</span>' +
        '<span class="rk-qv-fin-meta">Included</span></span></button>';
    }
    finishHtml += '<button type="button" class="rk-qv-fin rk-qv-fin--preview' + (state.framePreview ? ' on' : '') +
      '" data-rk-qv-frame-preview role="radio" aria-checked="' + (state.framePreview ? 'true' : 'false') + '">' +
      '<span class="rk-qv-fin-sw is-framed"></span><span><span class="rk-qv-fin-name">Framed</span>' +
      '<span class="rk-qv-fin-meta is-preview">Preview only</span></span></button>';
    finishHtml += '</div>';
    if (state.finInfoOpen) {
      finishHtml += '<p class="rk-qv-finish-note">' + finishNote + '</p>';
    }
    finishHtml += '</div>';

    var arHtml = tier === 'limited' ? '' :
      '<button type="button" class="rk-qv-ar" data-rk-qv-ar>' +
        '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>' +
        '<span>Preview on Your Wall</span></button>';

    var factsHtml =
      '<div class="rk-qv-facts">' +
        '<span class="rk-qv-fact"><span>✓</span>Museum-quality giclée</span>' +
        '<span class="rk-qv-fact"><span>✓</span>' + esc(meta.paperLabel) + '</span>' +
        '<span class="rk-qv-fact"><span>✓</span>' + esc(meta.longevity) + '</span>' +
        '<span class="rk-qv-fact"><span>✓</span>Cultural Passport</span>' +
      '</div>';

    var inclHtml =
      '<div class="rk-qv-incl rk-qv-incl--collapsible">' +
        '<button type="button" class="rk-qv-incl-toggle" data-rk-qv-incl-toggle aria-expanded="' + (state.inclOpen ? 'true' : 'false') + '">' +
          '<span class="rk-qv-lab rk-qv-lab--inline">Included · ' + meta.incl.length + ' items</span>' +
          '<span class="rk-qv-incl-chev' + (state.inclOpen ? ' is-open' : '') + '" aria-hidden="true">⌄</span>' +
        '</button>' +
        (state.inclOpen
          ? '<ul>' + meta.incl.map(function (x) { return '<li><span>✓</span>' + esc(x) + '</li>'; }).join('') + '</ul>'
          : '') +
      '</div>';

    var noteHtml = '';
    if (card.note) {
      noteHtml =
        '<div class="rk-qv-note">' +
          '<p class="rk-qv-note-lab">Editor\'s Note</p>' +
          '<p class="rk-qv-note-body' + (state.noteOpen ? ' is-open' : '') + '">' + esc(card.note) + '</p>' +
          '<button type="button" class="rk-qv-note-toggle" data-rk-qv-note-toggle>' + (state.noteOpen ? 'Less' : 'More') + '</button>' +
        '</div>';
    }

    var spacesHtml = '';
    if (spaces.length) {
      spacesHtml = '<div class="rk-qv-spaces-row"><span class="rk-qv-lab rk-qv-lab--inline">Perfect for</span>';
      spaces.forEach(function (sp) {
        spacesHtml += '<span class="rk-qv-space-chip">' + esc(sp) + '</span>';
      });
      spacesHtml += '</div>';
    }

    var chips = [];
    if (heritage) chips.push({ label: heritage, filter: 'heritage', value: card.heritage || heritage });
    if (style) chips.push({ label: style, filter: 'style', value: style });
    if (card.subject) chips.push({ label: card.subject, filter: 'subject', value: card.subject });
    if (card.colour) chips.push({ label: card.colour, filter: 'colour', value: card.colour });
    if (spaces[0]) chips.push({ label: spaces[0], filter: 'space', value: spaces[0] });
    var chipsHtml = '';
    if (chips.length) {
      chipsHtml = '<div class="rk-qv-similar"><p class="rk-qv-lab">Browse Similar</p><div class="rk-qv-chips">';
      chips.forEach(function (c) {
        chipsHtml += '<button type="button" class="rk-qv-chip" data-rk-qv-chip="' + esc(c.filter) +
          '" data-value="' + esc(c.value || c.label) + '">' + esc(c.label) + '</button>';
      });
      chipsHtml += '</div></div>';
    }

    var showPayMount = true;
    var artistSlug = (artist || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');
    var artistHref = artistSlug ? '/artists/' + artistSlug : '/pages/artists';
    var artistCount = 0;
    if (artist) {
      var artistEsc = artist.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
      artistCount = document.querySelectorAll('.rk-pc[data-artist="' + artistEsc + '"]').length;
      if (!artistCount) {
        shopCatalogItems().forEach(function (row) {
          if (row && row.artist && String(row.artist).toLowerCase() === artist.toLowerCase()) {
            artistCount += 1;
          }
        });
      }
    }
    var reviewN = parseInt(card.reviews, 10) || 0;
    var showRating = card.rating && reviewN >= 3;
    var ratingRow = '';
    if (showRating || card.sellingFast) {
      ratingRow = '<div class="rk-qv-rating">';
      if (showRating) {
        ratingRow +=
          starsHtml(card.rating) +
          '<span>' +
          esc(card.rating) +
          ' · ' +
          esc(String(reviewN)) +
          ' reviews</span>';
      }
      if (card.sellingFast) {
        ratingRow +=
          '<span class="rk-qv-selling-fast">● Selling Fast</span>';
      }
      ratingRow += '</div>';
    }

    var artistLine = '';
    if (artist) {
      artistLine = '<p class="rk-qv-artist-line"><a href="' + esc(artistHref) + '">' + esc(artist) + '</a>';
      if (card.artistLoc || artistCount) {
        artistLine += '<span class="rk-qv-artist-meta-inline">';
        if (card.artistLoc) artistLine += ' · ' + esc(card.artistLoc);
        if (artistCount) artistLine += ' · ' + artistCount + ' work' + (artistCount !== 1 ? 's' : '');
        artistLine += '</span>';
      }
      artistLine += '</p>';
    }

    scroll.innerHTML =
      (heritage ? '<p class="rk-qv-heritage">' + esc(heritage) + '</p>' : '') +
      '<h2 class="rk-qv-h2">' + esc(title) + (year ? '<span class="rk-qv-yr">Yr. ' + esc(year) + '</span>' : '') + '</h2>' +
      '<p class="rk-qv-sub">' + esc([style, heritage ? heritage + ' Fine Art Print' : ''].filter(Boolean).join(' · ')) + '</p>' +
      artistLine +
      ratingRow +
      '<div class="rk-qv-badges"><span class="rk-qv-tier' +
        (tier === 'limited' ? ' is-le' : '') +
        (tier === 'collector' ? ' is-co' : '') +
        '">' + esc(card.tierLabel || meta.label) + '</span>' + edHtml + '</div>' +
      '<div class="rk-qv-price-row' + (showPayMount ? '' : ' has-meta') + '"><span class="rk-qv-price">' + money(price) +
        '</span><span class="rk-qv-price-meta">' + esc([formatSizeLabel(sizeLabel).primary, finishDisplay].filter(Boolean).join(' · ')) + '</span></div>' +
      '<div class="rk-qv-pay is-empty" data-rk-qv-pay hidden></div>' +
      shippingLineHtml(price, mounted) +
      sizesHtml +
      finishHtml +
      arHtml +
      factsHtml +
      inclHtml +
      noteHtml +
      spacesHtml +
      pairsHtml() +
      chipsHtml +
      '<div class="rk-qv-trust">' + meta.trust.map(function (t, i) {
        return esc(t) + (i < meta.trust.length - 1 ? ' ·' : '');
      }).join(' ') + '</div>' +
      '<a class="rk-qv-details" href="' + esc(p.url || ('/products/' + p.handle)) + '">View full product details<span style="margin-left:4px">→</span></a>';

    /* Curator's Note: "More" only when the 2-line clamp actually cuts the note (owner,
       19 Oct 2026 — short notes showed a toggle with nothing more to read). */
    (function () {
      var nb = scroll.querySelector('.rk-qv-note-body'), nt = scroll.querySelector('[data-rk-qv-note-toggle]');
      if (!nb || !nt || nb.classList.contains('is-open')) return;
      /* Measured only once the note has real layout: the dialog is still opening when this
         runs, the note then measures 0 x 0, and every note lost its toggle (owner, 22 Oct).
         Re-measured on resize; with no layout yet the toggle stays visible. */
      function fit() {
        if (!nb.isConnected || nb.classList.contains('is-open')) return;
        if (!nb.clientHeight) { nt.hidden = false; return; }
        nt.hidden = !(nb.scrollHeight > nb.clientHeight + 1);
      }
      if (typeof ResizeObserver !== 'undefined') { new ResizeObserver(fit).observe(nb); }
      requestAnimationFrame(fit); setTimeout(fit, 350); setTimeout(fit, 900);
    })();

    if (atc) {
      if (state.framePreview) {
        atc.textContent = 'Framed — Preview Only';
        atc.disabled = true;
      } else {
        atc.textContent = 'Add to Cart — ' + money(price);
        atc.disabled = !(v && v.available !== false);
      }
    }
    if (wish) {
      var pid = String(p.id);
      var on = getWish().some(function (w) { return wishEntryId(w) === pid; });
      wish.classList.toggle('on', on);
      wish.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    var sheet = document.querySelector('[data-rk-qv-share-sheet]');
    if (sheet) { sheet.hidden = true; sheet.classList.remove('is-open'); }
    state.shareOpen = false;

    renderMediaGallery();
    syncPaymentTerms(p.handle, v && v.id, price);
  }

  function openQVFromHandle(handle, cardEl) {
    ensureUI();
    cardEl = resolveShopCardEl(handle, cardEl);
    if (cardEl) {
      state.card = readCardMeta(cardEl);
      var herEl = cardEl.querySelector('.rk-pc-heritage');
      if (state.card && !state.card.heritageLabel && herEl) {
        state.card.heritageLabel = (herEl.textContent || '').trim();
      }
    }

    state.sizeLabel = '';
    state.finishLabel = '';
    state.tab = 'artwork';
    state.mediaIndex = 0;
    state.inclOpen = false;
    state.noteOpen = false;
    state.framePreview = false;
    state.finInfoOpen = false;

    var root = document.getElementById('rk-qv-root');
    var scroll = document.querySelector('[data-rk-qv-scroll]');
    if (scroll) scroll.innerHTML = '<p style="font-family:Assistant,sans-serif;font-size:14px;color:#5c5c5c">Loading…</p>';
    root.hidden = false;
    root.classList.add('is-open');
    root.setAttribute('aria-label', 'Quick view' + (state.card && state.card.heritageLabel ? ': ' + state.card.heritageLabel : ''));
    document.body.classList.add('rk-qv-lock');
    state.open = true;
    setTab('artwork');

    fetch(productJs(handle), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (product) {
        state.product = product;
        initSelectionFromProduct(product);
        if (!state.card || !state.card.heritage) {
          var live = resolveShopCardEl(product.handle, null);
          if (live) state.card = readCardMeta(live);
        }
        state.card = reconcileCardTierFromProduct(state.card, product);
        renderQVBody();
      })
      .catch(function () {
        if (scroll) scroll.innerHTML = '<p style="font-family:Assistant,sans-serif;font-size:14px;color:#5c5c5c">Could not load this product.</p>';
      });
  }

  function openQV(cardEl) {
    var handle = cardEl.getAttribute('data-handle');
    if (!handle) return;
    openQVFromHandle(handle, cardEl);
  }

  function closeQV() {
    var root = document.getElementById('rk-qv-root');
    if (!root) return;
    root.classList.remove('is-open');
    root.hidden = true;
    document.body.classList.remove('rk-qv-lock');
    state.open = false;
    state.product = null;
    closeAR();
    setTab('artwork');
  }

  function openAR() {
    ensureUI();
    var ov = document.getElementById('rk-ar-root');
    var frame = document.querySelector('[data-rk-ar-frame]');
    var img = document.querySelector('[data-rk-ar-img]');
    var label = document.querySelector('[data-rk-ar-label]');
    var v = currentVariant();
    var slideImg = document.querySelector('[data-rk-qv-media-slots] .rk-qv-slide.on img, [data-rk-qv-media-slots] .rk-qv-slide--artwork img');
    var src = '';
    if (slideImg) src = slideImg.currentSrc || slideImg.src || '';
    if (!src && state.product) {
      src = state.product.featured_image || (state.product.images && state.product.images[0]) || '';
      if (typeof src !== 'string') src = (src && src.src) || '';
    }
    if (img && src) img.src = src;
    if (frame) {
      var orient = ((state.card && state.card.orient) || '').toLowerCase();
      frame.classList.toggle('is-landscape', orient.indexOf('landscape') !== -1);
    }
    if (label) {
      label.textContent = 'Preview · ' +
        ([state.sizeLabel, state.finishLabel].filter(Boolean).join(' · ')
          ? [state.sizeLabel, state.finishLabel].filter(Boolean).join(' · ') + ' · '
          : '') +
        money(currentPriceCents());
    }
    ov.hidden = false;
    ov.classList.add('is-open');
  }

  function closeAR() {
    var ov = document.getElementById('rk-ar-root');
    if (!ov) return;
    ov.classList.remove('is-open');
    ov.hidden = true;
  }

  function shopBrowsePath() {
    var link = document.querySelector('a[href*="/collections/all"]');
    if (link) {
      try {
        return new URL(link.getAttribute('href'), window.location.origin).pathname || '/collections/all';
      } catch (e) { /* fall through */ }
    }
    return '/collections/all';
  }

  function applyChipFilter(name, value) {
    closeQV();
    if (!name || !value) return;

    var val = String(value).trim();
    var shop = document.getElementById('rk-shop-grid');

    /* Off shop (artist, PDP, search, etc.): deep-link into browse with this filter */
    if (!shop) {
      var params = new URLSearchParams();
      params.set(name, val);
      window.location.href = shopBrowsePath() + '?' + params.toString();
      return;
    }

    var target = null;
    var valLc = val.toLowerCase();
    shop.querySelectorAll('[data-rk-filter="' + name + '"]').forEach(function (input) {
      var label = (input.getAttribute('data-label') || '').trim();
      var on = input.value === val ||
        label === val ||
        label.toLowerCase() === valLc ||
        input.value.toLowerCase() === valLc;
      input.checked = on;
      if (on && !target) {
        // Prefer desktop sidebar input so pills (which read data-rk-side) stay in sync
        if (input.closest('[data-rk-side]')) target = input;
        else if (!target) target = input;
      }
    });

    // Shop grid only runs filterAll() when change originates on a [data-rk-filter] input
    if (target) {
      target.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      shop.dispatchEvent(new CustomEvent('rk-filters-changed', { bubbles: true }));
    }
    shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function doAddFromQV(closeAfter) {
    if (state.framePreview) return Promise.reject();
    var v = currentVariant();
    if (!v) return Promise.reject();
    var props = {};
    if (state.sizeLabel) props.Size = state.sizeLabel;
    if (state.finishLabel) props.Finish = state.finishLabel;
    return addToCart(v.id, 1, Object.keys(props).length ? props : null).then(function () {
      if (closeAfter) { closeAR(); closeQV(); }
    });
  }

  function bind() {
    ensureUI();
    /* Safety net: a frame left without its print (removed anywhere, by anything) is
       swept on the next page load; the cart page reloads to show what Shopify holds. */
    refreshCart().then(function (cart) {
      return sweepOrphanFrames(cart).then(function (did) {
        if (!did) return;
        if (/\/cart\/?$/.test(location.pathname)) location.reload(); else refreshCart();
      });
    });

    /* The cart page's REMOVE is a plain link (/cart/change?id=<key>&quantity=0) that
       reloads the page — no script runs after it. For a framed print, remove the print
       and its frame together first, then reload. */
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href*="/cart/change"]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var u; try { u = new URL(a.getAttribute('href'), location.href); } catch (err) { return; }
      var key = u.searchParams.get('id') || u.searchParams.get('line');
      if (!key || u.searchParams.get('quantity') !== '0' || /^\d+$/.test(key) && !u.searchParams.get('id')) return;
      e.preventDefault();
      removeLine(key).then(function () { location.reload(); }, function () { location.href = a.href; });
    }, true);

    document.addEventListener('cart:open', function () {
      refreshCart().then(openMiniCart);
    });
    document.addEventListener('cart:refresh', function (e) {
      refreshCart().then(function () {
        if (e && e.detail && e.detail.open) openMiniCart();
      });
    });

    /* Capture-phase: heart sits inside <a.rk-pc>; stop navigation and toggle wishlist */
    document.addEventListener('click', function (e) {
      var pcWish = e.target.closest('.rk-pc-wish');
      if (!pcWish) return;
      e.preventDefault();
      e.stopPropagation();
      var pid = String(pcWish.getAttribute('data-wish-id') || '');
      if (!pid) return;
      var handle = pcWish.getAttribute('data-wish-handle') || '';
      if (!handle) {
        var card = pcWish.closest('.rk-pc');
        if (card) handle = card.getAttribute('data-handle') || '';
      }
      var entries = getWish();
      var ix = entries.findIndex(function (w) { return wishEntryId(w) === pid; });
      if (ix === -1) entries.push({ id: pid, handle: handle });
      else entries.splice(ix, 1);
      setWish(entries);
      var on = ix === -1;
      document.querySelectorAll('.rk-pc-wish[data-wish-id="' + pid + '"]').forEach(function (b) {
        b.classList.toggle('on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var wbox = document.querySelector('[data-rk-mini-wish]');
      if (wbox && wbox.classList.contains('is-open')) refreshWishlist();
    }, true);

    document.addEventListener('click', function (e) {
      var dockCart = e.target.closest('[data-action="cart"]');
      if (dockCart) {
        e.preventDefault();
        e.stopPropagation();
        refreshCart().then(openMiniCart);
        return;
      }

      var qvBtn = e.target.closest('[data-rk-qv]');
      if (qvBtn) {
        e.preventDefault();
        e.stopPropagation();
        openQV(qvBtn.closest('.rk-pc, .rk-tp-pick-tile') || qvBtn);
        return;
      }

      var cartBtn = e.target.closest('[data-rk-add-cart], [data-rk-add-cart-handle]');
      if (cartBtn && !e.target.closest('#rk-qv-root') && !e.target.closest('#rk-ar-root')) {
        e.preventDefault();
        e.stopPropagation();
        var id = cartBtn.getAttribute('data-rk-add-cart');
        var handle = cartBtn.getAttribute('data-rk-add-cart-handle');
        cartBtn.disabled = true;
        var prev = cartBtn.textContent;

        function finishAdd(variantId) {
          if (!variantId) {
            cartBtn.disabled = false;
            return;
          }
          addToCart(variantId, 1, null)
            .then(function () {
              cartBtn.textContent = 'Added';
              setTimeout(function () {
                cartBtn.textContent = prev || 'Add to Cart';
                cartBtn.disabled = false;
              }, 1200);
            })
            .catch(function () { cartBtn.disabled = false; });
        }

        if (id) {
          finishAdd(id);
          return;
        }

        if (handle) {
          fetch('/products/' + encodeURIComponent(handle) + '.js')
            .then(function (r) {
              if (!r.ok) throw new Error('product');
              return r.json();
            })
            .then(function (p) {
              var variants = (p && p.variants) || [];
              var v = null;
              for (var i = 0; i < variants.length; i++) {
                if (variants[i].available) { v = variants[i]; break; }
              }
              if (!v) v = variants[0] || null;
              if (!v) throw new Error('novariant');
              cartBtn.setAttribute('data-rk-add-cart', String(v.id));
              cartBtn.removeAttribute('data-rk-add-cart-handle');
              if (!v.available) {
                cartBtn.textContent = 'Sold Out';
                cartBtn.setAttribute('aria-disabled', 'true');
                return;
              }
              finishAdd(String(v.id));
            })
            .catch(function () { cartBtn.disabled = false; });
          return;
        }

        cartBtn.disabled = false;
        return;
      }

      if (e.target.closest('[data-rk-cart-toggle]')) {
        e.preventDefault();
        var box = document.querySelector('[data-rk-mini-cart]');
        if (box && box.classList.contains('is-open')) closeMiniCart();
        else refreshCart().then(openMiniCart);
        return;
      }

      if (e.target.closest('[data-rk-wishlist-toggle]')) {
        e.preventDefault();
        var wbox = document.querySelector('[data-rk-mini-wish]');
        if (wbox && wbox.classList.contains('is-open')) closeMiniWishlist();
        else refreshWishlist().then(openMiniWishlist);
        return;
      }

      if (e.target.closest('[data-rk-mw-close]')) { closeMiniWishlist(); return; }

      var mwRem = e.target.closest('[data-rk-mw-remove]');
      if (mwRem) { e.preventDefault(); removeWishId(mwRem.getAttribute('data-rk-mw-remove')); return; }

      var mwAtc = e.target.closest('[data-rk-mw-atc]');
      if (mwAtc) {
        e.preventDefault();
        var vid = mwAtc.getAttribute('data-rk-mw-atc');
        mwAtc.disabled = true;
        addToCart(vid, 1, null)
          .then(function () {
            closeMiniWishlist();
            refreshCart().then(openMiniCart);
          })
          .catch(function () { mwAtc.disabled = false; });
        return;
      }

      var mwQv = e.target.closest('[data-rk-mw-qv]');
      if (mwQv) {
        e.preventDefault();
        var wh = mwQv.getAttribute('data-rk-mw-qv');
        closeMiniWishlist();
        openQVFromHandle(wh, null);
        return;
      }

      if (e.target.closest('[data-rk-mc-close]')) { closeMiniCart(); return; }
      var rem = e.target.closest('[data-rk-mc-remove]');
      if (rem) { e.preventDefault(); removeLine(rem.getAttribute('data-rk-mc-remove')); return; }

      if (e.target.closest('[data-rk-qv-close]') || e.target.id === 'rk-qv-root') {
        closeQV();
        return;
      }

      var sizeBtn = e.target.closest('[data-rk-qv-size]');
      if (sizeBtn) {
        state.sizeLabel = sizeBtn.getAttribute('data-rk-qv-size') || '';
        renderQVBody();
        return;
      }

      var finPreview = e.target.closest('[data-rk-qv-frame-preview]');
      if (finPreview) {
        state.framePreview = true;
        state.finishLabel = '';
        renderQVBody();
        return;
      }

      var finBtn = e.target.closest('[data-rk-qv-finish]');
      if (finBtn) {
        state.framePreview = false;
        state.finishLabel = finBtn.getAttribute('data-rk-qv-finish') || '';
        renderQVBody();
        return;
      }

      if (e.target.closest('[data-rk-qv-fin-info]')) {
        state.finInfoOpen = !state.finInfoOpen;
        renderQVBody();
        return;
      }

      if (e.target.closest('[data-rk-qv-incl-toggle]')) {
        state.inclOpen = !state.inclOpen;
        renderQVBody();
        return;
      }

      if (e.target.closest('[data-rk-qv-note-toggle]')) {
        state.noteOpen = !state.noteOpen;
        renderQVBody();
        return;
      }

      if (e.target.closest('[data-rk-qv-media-prev]')) {
        setMediaIndex(state.mediaIndex - 1);
        return;
      }

      if (e.target.closest('[data-rk-qv-media-next]')) {
        setMediaIndex(state.mediaIndex + 1);
        return;
      }

      var thumbBtn = e.target.closest('[data-rk-qv-thumb]');
      if (thumbBtn) {
        setMediaIndex(parseInt(thumbBtn.getAttribute('data-rk-qv-thumb'), 10) || 0);
        return;
      }

      var tab = e.target.closest('[data-rk-qv-tab]');
      if (tab) { setTab(tab.getAttribute('data-rk-qv-tab')); return; }

      if (e.target.closest('[data-rk-qv-ar]')) { openAR(); return; }

      if (e.target.closest('[data-rk-ar-atc]')) {
        e.stopPropagation();
        doAddFromQV(true).catch(function () {});
        return;
      }

      if (e.target.closest('[data-rk-ar-ov]') && !e.target.closest('[data-rk-ar-atc]')) {
        closeAR();
        return;
      }

      var pair = e.target.closest('[data-rk-qv-pair]');
      if (pair) {
        var h = pair.getAttribute('data-rk-qv-pair');
        var card = resolveShopCardEl(h, null);
        if (card) openQV(card);
        else openQVFromHandle(h, null);
        return;
      }

      var chip = e.target.closest('[data-rk-qv-chip]');
      if (chip) {
        applyChipFilter(chip.getAttribute('data-rk-qv-chip'), chip.getAttribute('data-value'));
        return;
      }

      if (e.target.closest('[data-rk-qv-atc]') && !e.target.closest('[data-rk-ar-atc]')) {
        var btn = e.target.closest('[data-rk-qv-atc]');
        btn.disabled = true;
        doAddFromQV(true).catch(function () { btn.disabled = false; renderQVBody(); });
        return;
      }

      if (e.target.closest('[data-rk-qv-wish]') && state.product) {
        var entries = getWish();
        var pid = String(state.product.id);
        var handle = state.product.handle || '';
        var ix = entries.findIndex(function (w) { return wishEntryId(w) === pid; });
        if (ix === -1) entries.push({ id: pid, handle: handle });
        else entries.splice(ix, 1);
        setWish(entries);
        renderQVBody();
        document.querySelectorAll('.rk-pc-wish[data-wish-id="' + pid + '"]').forEach(function (b) {
          b.classList.toggle('on', ix === -1);
          b.setAttribute('aria-pressed', ix === -1 ? 'true' : 'false');
        });
        var wbox = document.querySelector('[data-rk-mini-wish]');
        if (wbox && wbox.classList.contains('is-open')) refreshWishlist();
        return;
      }

      if (e.target.closest('[data-rk-qv-share]')) {
        var sheet = document.querySelector('[data-rk-qv-share-sheet]');
        if (sheet) {
          state.shareOpen = !state.shareOpen;
          sheet.hidden = !state.shareOpen;
          sheet.classList.toggle('is-open', state.shareOpen);
        }
        return;
      }

      var shareOpt = e.target.closest('[data-rk-share]');
      if (shareOpt && state.product) {
        var url = window.location.origin + (state.product.url || ('/products/' + state.product.handle));
        var kind = shareOpt.getAttribute('data-rk-share');
        if (kind === 'copy' && navigator.clipboard) navigator.clipboard.writeText(url);
        if (kind === 'pinterest') window.open('https://pinterest.com/pin/create/button/?url=' + encodeURIComponent(url), '_blank');
        if (kind === 'email') window.location.href = 'mailto:?subject=' + encodeURIComponent(state.product.title || 'Raknida') + '&body=' + encodeURIComponent(url);
        state.shareOpen = false;
        var sh = document.querySelector('[data-rk-qv-share-sheet]');
        if (sh) { sh.hidden = true; sh.classList.remove('is-open'); }
        return;
      }

      var mc = document.querySelector('[data-rk-mini-cart]');
      if (mc && mc.classList.contains('is-open')) {
        if (!e.target.closest('[data-rk-cart-slot]') && !e.target.closest('[data-rk-add-cart]') && !e.target.closest('[data-rk-qv-atc]') && !e.target.closest('[data-rk-ar-atc]')) {
          closeMiniCart();
        }
      }

      var mw = document.querySelector('[data-rk-mini-wish]');
      if (mw && mw.classList.contains('is-open')) {
        if (!e.target.closest('[data-rk-wish-slot]') && !e.target.closest('.rk-pc-wish')) {
          closeMiniWishlist();
        }
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeAR(); closeQV(); closeMiniCart(); closeMiniWishlist(); }
      if (!state.open) return;
      if (e.key === 'ArrowLeft') setMediaIndex(state.mediaIndex - 1);
      if (e.key === 'ArrowRight') setMediaIndex(state.mediaIndex + 1);
    });

    var qvTouchX = null;
    document.addEventListener('touchstart', function (e) {
      if (!e.target.closest('[data-rk-qv-stage]')) return;
      qvTouchX = e.touches[0].clientX;
    }, { passive: true });
    document.addEventListener('touchend', function (e) {
      if (qvTouchX === null || !e.target.closest('[data-rk-qv-stage]')) return;
      var dx = e.changedTouches[0].clientX - qvTouchX;
      if (Math.abs(dx) > 44) setMediaIndex(state.mediaIndex + (dx < 0 ? 1 : -1));
      qvTouchX = null;
    }, { passive: true });

    /* The cart page removes lines itself (cart.js → 'cart:updated'): sweep any frame
       left without its print, then reload so the page shows the cart Shopify holds. */
    document.addEventListener('cart:updated', function (e) {
      var cart = e && e.detail && e.detail.cart;
      if (!cart || !cart.items || !orphanFrames(cart).length) return;
      sweepOrphanFrames(cart).then(function (did) {
        if (!did) return;
        if (/\/cart\/?$/.test(location.pathname)) location.reload(); else refreshCart();
      });
    });

    document.addEventListener('rk-wishlist-change', function () {
      updateWishBadge();
      var wbox = document.querySelector('[data-rk-mini-wish]');
      if (wbox && wbox.classList.contains('is-open')) refreshWishlist();
    });

    window.addEventListener('storage', function (e) {
      if (e.key === 'rk-wishlist') updateWishBadge();
    });

    updateWishBadge();
    /* Sync heart UI on pages without shop-grid (search, tradition, etc.) */
    (function syncPcWishButtons() {
      var ids = getWish();
      document.querySelectorAll('.rk-pc-wish[data-wish-id]').forEach(function (btn) {
        var on = ids.some(function (w) { return wishEntryId(w) === String(btn.getAttribute('data-wish-id')); });
        btn.classList.toggle('on', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    })();
  }

  window.RaknidaQV = {
    open: openQV,
    close: closeQV,
    addToCart: addToCart,
    openMiniCart: openMiniCart,
    refreshCart: refreshCart,
    openMiniWishlist: openMiniWishlist,
    refreshWishlist: refreshWishlist,
    getWish: getWish,
    setWish: setWish
  };

  if (!customElements.get('mini-cart')) {
    customElements.define(
      'mini-cart',
      class RaknidaMiniCartBridge extends HTMLElement {
        open() {
          refreshCart().then(openMiniCart);
        }
        renderContents() {
          refreshCart().then(openMiniCart);
        }
        getSectionsToRender() {
          return [];
        }
        setActiveElement() {}
      }
    );
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
